import { useEffect, useState } from 'react'
import { CustomCellEditorProps } from 'ag-grid-react'
import { Box } from '@mui/material'
import { gridRootStyle } from '../../../../commons/AgGrid'
import { MultiInputDialog } from './MultiInputDialog'
import { WbsItemAdditionalPropertySelectOption } from '../../../../../../domain/entity/WbsItemAdditionalPropertyEntity'

interface Props extends CustomCellEditorProps {
  value: WbsItemAdditionalPropertySelectOption[]
}

export const WbsItemAdditionalPropertySelectOptionsCellEditor = (
  props: Props
) => {
  const { value, api, stopEditing } = props
  const [open, setOpen] = useState(true)
  const [inputItems, setInputItems] = useState(value)

  useEffect(() => {
    if (!open) {
      stopEditing()
    }
  }, [open])

  return (
    <Box sx={gridRootStyle}>
      <MultiInputDialog
        open={open}
        inputItems={inputItems}
        onSubmit={newInputItems => {
          props.onValueChange(newInputItems)
          setInputItems(newInputItems)
          setOpen(false)
        }}
        onClose={() => {
          api.stopEditing(true)
        }}
      />
    </Box>
  )
}
